<div fxFlex fxLayout="column" style="z-index: 2; position:absolute; width: 100%; height: 100%; overflow:hidden;">
  <app-header></app-header>
  <div fxFlex fxFill style="width: 100%; height: 100%; overflow: hidden;" class="">
    <router-outlet class="fill"></router-outlet>
  </div>
</div>
